import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { Button, Label, Select, Loader, LabeledInput } from 'oxyrion-ui/lib';
import {
  getIdFromProps,
  __,
  translateUserPosition,
  getServiceStatus,
  formatDate,
} from '../../../Utils';
import { connect, actions } from '../../../Store';
import { Title } from '../../../Components/ReusableComponents';
import EmailsSelector from '../../../Components/EmailsSelector';
import CommentItem from '../../../Components/CommentItem';
import API2 from '../../../API2';

const MainContainer = styled.div`
  padding: ${rem(16)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const InputWrapper = styled.div`
  padding: 10px 0px;
  width: ${rem(644)};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: ${rem(670)};
`;

const CustomButton = styled(Button)`
  margin: 0 ${rem(10)};
  width: ${rem(100)};
`;

const DescWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const photoBasePath = `${process.env.REACT_APP_IMAGES_PREFIX}/images/500x500`;

class HelpdeskDetial extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: false,
      readOnly: false,
      serviceId: null,
      customerName: null,
      userName: null,
      solver: null,
      name: null,
      selected: null,
      selected2: null,
      selected3: null,
      selectedMachine: null,
      description: null,
      dueDate: null,
      additionalEmails: [],
      machines: [],
      history: [],
      createdBy: {},
      files: [],
      options: [
        {
          name: __('Marketing'),
          value: 'marketing',
          children: [
            {
              name: __('Inštalácia'),
              value: 'instalation',
              children: [
                {
                  name: __('Výkladov'),
                  value: 'exposition',
                },
                {
                  name: __('Bannerov'),
                  value: 'banners',
                },
                {
                  name: __('Regálov'),
                  value: 'racks',
                },
                {
                  name: __('Svetelných zariadení'),
                  value: 'lights',
                },
                {
                  name: __('Vzorkovníkov'),
                  value: 'colormatching',
                },
                {
                  name: __('Iné'),
                  value: 'other',
                },
              ],
            },
            {
              name: __('Marketingový materiál'),
              value: 'marketingmaterial',
              children: [
                {
                  name: __('Katalógy'),
                  value: 'catalogs',
                },
                {
                  name: __('Vzorkovníky'),
                  value: 'colormatchers',
                },
                {
                  name: __('Marketingový materiál ostatný'),
                  value: 'marketingOther',
                },
                {
                  name: __('Karta bezpečnostných údajov alebo technický list'),
                  value: 'seccardorlist',
                },
                {
                  name: __('Ostatné marketingové informácie'),
                  value: 'marketingOtherInfo',
                },
                {
                  name: __('Iné'),
                  value: 'other',
                },
              ],
            },
            {
              name: __('Iné'),
              value: 'other',
            },
          ],
        },
        {
          name: __('Servis stroja'),
          value: 'marketing2',
          children: [
            {
              name: __('Servisná prehliadka'),
              value: 'serviceInspection',
              children: [],
            },
            {
              name: __('Servis'),
              value: 'service',
              children: [],
            },
            {
              name: __('Iné'),
              value: 'other',
            },
          ],
        },
        {
          name: __('Reklamácia'),
          value: 'claim',
          children: [
            {
              name: __('Preprava'),
              value: 'transit',
              children: [
                {
                  name: __('Poškodený tovar'),
                  value: 'damagedGoods',
                },
                {
                  name: __('Nedodaný tovar'),
                  value: 'notRecievedGoods',
                },
                {
                  name: __('Chýbajúce dokumenty'),
                  value: 'missingDocuments',
                },
                {
                  name: __('Iné'),
                  value: 'other',
                },
              ],
            },
            {
              name: __('Produkt'),
              value: 'product',
              children: [
                {
                  name: __('Vo farbe je kôra'),
                  value: 'colorHasCrust',
                },
                {
                  name: __('Produkt je poškodený'),
                  value: 'productDamaged',
                },
                {
                  name: __('Produkt sa javí vadný'),
                  value: 'productAppearsDefective',
                },
                {
                  name: __('Produkt je po záruke'),
                  value: 'productAfterWarranty',
                },
                {
                  name: __('Iné'),
                  value: 'other',
                },
              ],
            },
            {
              name: __('Aplikácia'),
              value: 'application',
              children: [
                {
                  name: __('Problém s aplikáciou'),
                  value: 'applicationProblem',
                },
                {
                  name: __('Vzhľad povrchu je nevyhovujúci'),
                  value: 'looksUnsatisfactory',
                },
                {
                  name: __('Odtieň je nerovnomerný'),
                  value: 'shadeUneven',
                },
                {
                  name: __('Povrch vykazuje chyby'),
                  value: 'surfaceDefects',
                },
                {
                  name: __('Farba sa olupuje'),
                  value: 'paintPeelsOff',
                },
                {
                  name: __('Povrch hrdzavie'),
                  value: 'surfaceRusting',
                },
                {
                  name: __('Iné'),
                  value: 'other',
                },
              ],
            },
            {
              name: __('Tónovanie'),
              value: 'toning',
              children: [
                {
                  name: __('Nesprávny odtieň'),
                  value: 'incorrectShade',
                },
                {
                  name: __('Odtieň je nerovnomerný'),
                  value: 'shadeUneven',
                },
                {
                  name: __('Iné'),
                  value: 'other',
                },
              ],
            },
            {
              name: __('Iné'),
              value: 'other',
            },
          ],
        },
        {
          name: __('Iné'),
          value: 'other',
          children: [],
        },
      ],
    };
  }

  async componentDidMount() {
    const serviceId = getIdFromProps(this.props);
    this.setState({
      userName: `${this.props.user.name} ${this.props.user.surname}`,
      customerName: this.props.user.customer.name,
      createdBy: {
        role: 'customer',
        display_name: `${this.props.user.name} ${this.props.user.surname}`,
      },
    });
    if (serviceId !== 'new') {
      await this.fetch(serviceId);
    }
    await this.fetchMachines();

    actions.setActiveMenuItem('47');
  }

  async onSubmit() {
    const { descFiles, serviceId } = this.state;

    this.setState({
      saveLoading: true,
    });

    if (this.state.readOnly) {
      const dataPut = {
        additional_emails: this.state.additionalEmails,
      };
      await API2.putB2BHelpdeskServiceAction(serviceId, {
        body: dataPut,
      });
      this.setState({
        saveLoading: false,
      });
    } else if (this.checkData()) {
      const dataPost = {
        title: this.state.name,
        name: this.state.selected,
        case: this.state.selected2,
        machine_type: this.state.selected3,
        machine_id: this.state.selectedMachine
          ? [this.state.selectedMachine]
          : [],
        description: this.state.description,
        user_id: this.props.user._id,
        customer_id: this.props.user.customer._id,
        additional_emails: this.state.additionalEmails,
      };

      try {
        const result = await API2.postB2BHelpdeskServiceAction({
          body: dataPost,
        });

        if (descFiles && descFiles.length) {
          await Promise.all(
            descFiles.map(item =>
              API2.postB2BHelpdeskServiceAttachmentAction(result._id, {
                body: {
                  attachment: Object.assign(item, { description_file: true }),
                },
                descriptionFile: true,
              }),
            ),
          );
        }

        this.props.history.push(`/helpdesk/${result._id}`);
        this.fetch(result._id);
      } catch (e) {
        console.log(e);
      }
    } else {
      alert(__('Je potrebné vyplniť všetky polia'));
    }
  }

  async fetch(serviceId) {
    this.setState({ loader: true });
    try {
      const service = await API2.getB2BHelpdeskServiceAction(serviceId);
      const files = await API2.getB2BHelpdeskServiceAttachmentsAction(
        serviceId,
      );
      const history = await API2.getB2bHelpdeskServiceHistoryAction(serviceId);

      this.setState({
        serviceId: service._id,
        loader: false,
        readOnly: true,
        customerName: service.customer_name,
        userName: service.user_name,
        selected: service.name,
        selected2: service.case,
        selected3: service.machine_type,
        description: service.description,
        history: history.history,
        additionalEmails: service.additional_emails || [],
        name: service.title,
        solver: service.solver_name,
        createdBy: service.created_by,
        files,
        status: service.status,
        dueDate: service.due_date,
        saveLoading: false,
      });
    } catch (e) {
      this.setState({ loader: false });
      this.props.history.push('/helpdesk');
    }
  }

  async fetchMachines() {
    try {
      return await API2.getB2BCustomerMachinesAction().then(res => {
        const machines = res.machines.map(item => ({
          value: item._id,
          label: item.name,
          additionalData: {
            installation_address: item.installation_address,
            machine_type: item.type,
            toning_system: item.toning_system,
          },
        }));
        this.setState({
          machines,
        });
      });
      // return true;
    } catch (e) {
      return [];
    }
  }

  checkData() {
    let isValid = true;

    if (!this.state.name) {
      isValid = false;
    }

    if (!this.state.description) {
      isValid = false;
    }

    if (!this.state.selected) {
      isValid = false;
    }

    if (this.state.selected === __('Servis stroja')) {
      if (!this.state.selectedMachine) {
        isValid = false;
      }
    } else if (this.state.selected !== __('Servis stroja')) {
      if (this.state.selected !== __('Iné')) {
        if (this.state.selected2 !== __('Iné')) {
          if (!this.state.selected3) {
            isValid = false;
          }
        }
      }
    }

    return isValid;
  }

  async saveToHistory(data) {
    const { serviceId } = this.state;
    const { description, files } = data;

    try {
      const result = await API2.putB2bHelpdeskHistoryAction(serviceId, {
        body: {
          user_id: this.props.user._id,
          description,
        },
      });

      await Promise.all(
        files.map(item =>
          API2.postB2BHelpdeskServiceAttachmentAction(serviceId, {
            body: { attachment: item },
            historyId: result.history[result.history.length - 1]._id,
          }),
        ),
      );

      const history = await API2.getB2bHelpdeskServiceHistoryAction(serviceId);

      this.setState({
        history: history.history,
        description: '',
      });
    } catch (e) {
      console.log(e);
    }
  }

  handleChange(type, value) {
    let {
      customerName,
      userName,
      solver,
      name,
      selected,
      selected2,
      selected3,
      selectedMachine,
      description,
      descFiles,
    } = this.state;

    if (type === 'customerName') {
      customerName = value;
    } else if (type === 'description') {
      if (value.description) {
        description = value.description;
      } else if (value.files) {
        descFiles = value.files;
      }
    } else if (type === 'userName') {
      userName = value;
    } else if (type === 'solver') {
      solver = value;
    } else if (type === 'name') {
      name = value;
    }

    if (type === 'selected') {
      selected = value;
      selected2 = null;
      selected3 = null;
      selectedMachine = null;
    }

    if (type === 'selected2') {
      selected2 = value;
      selected3 = null;
      selectedMachine = null;
    }

    if (type === 'selected3') {
      selected3 = value;
    }

    if (type === 'selectedMachine') {
      selectedMachine = value;
    }

    this.setState({
      customerName,
      userName,
      solver,
      name,
      selected,
      selected2,
      selected3,
      selectedMachine,
      description,
      descFiles,
    });
  }

  render() {
    const labeledWidth = { width: rem(600) };
    const {
      loader,
      // customerName,
      solver,
      name,
      readOnly,
      additionalEmails,
      options,
      selected,
      selected2,
      selected3,
      selectedMachine,
      machines,
      history,
      createdBy,
      description,
      files,
      saveLoading,
      status,
      dueDate,
      // serviceId,
    } = this.state;
    const options2 = this.state.options.find(
      c => c.name === this.state.selected,
    );
    const options3 =
      options2 &&
      options2.children &&
      options2.children.find(c => c.name === this.state.selected2);
    const firmEmail =
      this.props.firm === 'SK' ? 'predaj@dejmark.com' : 'prodej@dejmark.com';
    const defaultEmails = [this.props.user.email, firmEmail];

    if (loader) {
      return (
        <MainContainer>
          <Loader size="xl" />
        </MainContainer>
      );
    }

    return (
      <MainContainer>
        {readOnly ? (
          <Title>{__('Požiadavka')}</Title>
        ) : (
          <Title>{__('Nová požiadavka')}</Title>
        )}
        {/* <InputWrapper>
          <LabeledInput
            onChange={e => this.handleChange('customerName', e.target.value)}
            style={labeledWidth}
            labelText={__('Zákazník')}
            value={customerName}
            disabled
          />
        </InputWrapper> */}
        {getIdFromProps(this.props) !== 'new' && (
          <InputWrapper>
            <LabeledInput
              onChange={e => this.handleChange('userName', e.target.value)}
              style={labeledWidth}
              labelText={__('Vytvoril')}
              value={createdBy.display_name}
              disabled
            />
          </InputWrapper>
        )}
        {this.state.solver && (
          <InputWrapper>
            <LabeledInput
              onChange={e => this.handleChange('solver', e.target.value)}
              style={labeledWidth}
              labelText={__('Riešiteľ')}
              value={solver}
              disabled
            />
          </InputWrapper>
        )}
        <InputWrapper>
          <LabeledInput
            onChange={e => this.handleChange('name', e.target.value)}
            style={labeledWidth}
            labelText={__('Názov požiadavky*')}
            placeholder={__('Zadajte názov požiadavky')}
            value={name}
            disabled={readOnly}
          />
        </InputWrapper>
        <InputWrapper>
          <Label>{__('Požiadavka*')}</Label>
          <Select
            icon="arrow-down"
            iconRight
            value={selected}
            onChange={e => this.handleChange('selected', e.target.value)}
            disabled={readOnly}
          >
            <option value="">{__('Vyberte možnosť')}</option>
            {options.map(s => {
              return (
                <option selected={s.name === selected} value={s.name}>
                  {s.name}
                </option>
              );
            })}
          </Select>
        </InputWrapper>
        {selected && selected !== __('Iné') && (
          <InputWrapper>
            <Label>{__('Oblasť*')}</Label>
            <Select
              icon="arrow-down"
              iconRight
              value={selected2}
              onChange={e => this.handleChange('selected2', e.target.value)}
              disabled={readOnly}
            >
              <option value="">{__('Vyberte možnosť')}</option>
              {options2 &&
                options2.children &&
                options2.children.map(s => {
                  return (
                    <option selected={s.name === selected2} value={s.name}>
                      {s.name}
                    </option>
                  );
                })}
            </Select>
          </InputWrapper>
        )}
        {selected === __('Servis stroja') && selected2 && (
          <InputWrapper>
            <Label>{__('Stroj')}</Label>
            <Select
              icon="arrow-down"
              iconRight
              value={selectedMachine}
              onChange={e =>
                this.handleChange('selectedMachine', e.target.value)
              }
              disabled={readOnly}
            >
              <option value="">{__('Vyberte možnosť')}</option>
              {machines &&
                machines.map(m => {
                  return (
                    <option
                      selected={m.value === selectedMachine}
                      value={m.value}
                    >
                      {`${m.label} (${m.additionalData.machine_type} - ${
                        m.additionalData.installation_address.street
                      }, ${m.additionalData.installation_address.postal_code} ${
                        m.additionalData.installation_address.city
                      })
                      `}
                    </option>
                  );
                })}
            </Select>
          </InputWrapper>
        )}
        {selected !== __('Servis stroja') &&
          selected2 &&
          selected2 !== __('Iné') && (
            <InputWrapper>
              <Label>{__('Druh*')}</Label>
              <Select
                icon="arrow-down"
                iconRight
                value={selected3}
                onChange={e => this.handleChange('selected3', e.target.value)}
                disabled={readOnly}
              >
                <option value="">{__('Vyberte možnosť')}</option>
                {options3 &&
                  options3.children &&
                  options3.children.map(s => {
                    return (
                      <option selected={s.name === selected3} value={s.name}>
                        {s.name}
                      </option>
                    );
                  })}
              </Select>
            </InputWrapper>
          )}
        {getIdFromProps(this.props) !== 'new' && (
          <InputWrapper>
            <LabeledInput
              onChange={e => this.handleChange('name', e.target.value)}
              style={labeledWidth}
              labelText={__('Stav')}
              value={getServiceStatus({
                status,
                solver,
              })}
              disabled
            />
          </InputWrapper>
        )}
        {getIdFromProps(this.props) !== 'new' && (
          <InputWrapper>
            <LabeledInput
              onChange={e => this.handleChange('name', e.target.value)}
              style={labeledWidth}
              labelText={__('Predpokladaný termnín dokončenia')}
              value={dueDate ? formatDate(moment(dueDate)) : __('Neznámy')}
              disabled
            />
          </InputWrapper>
        )}
        <InputWrapper>
          <Label>{__('Popis požiadavky*')}</Label>
        </InputWrapper>
        <CommentItem
          isNew={!this.state.serviceId}
          showSaveButton={false}
          data={{
            img: `${photoBasePath}/${createdBy && createdBy.profile_picture}`,
            name: createdBy && createdBy.display_name,
            role: createdBy && translateUserPosition(createdBy.role),
            text: description,
          }}
          downloadFunction={async fullPath => {
            return API2.getB2BHelpdeskServiceAttachmentDownloadAction(
              this.state.serviceId,
              encodeURIComponent(fullPath),
            );
          }}
          attachments={files.filter(f => f.description_file)}
          saveEveryChange
          history={this.props.history}
          onMessageSave={d => this.handleChange('description', d)}
        />
        <InputWrapper>
          <Label>{__('Diskusia')}</Label>
        </InputWrapper>
        {history &&
          history.map(item => {
            return (
              <CommentItem
                isNew={false}
                history={this.props.history}
                attachments={item.attachments}
                downloadFunction={async fullPath => {
                  return API2.getB2BHelpdeskServiceAttachmentDownloadAction(
                    this.state.serviceId,
                    encodeURIComponent(fullPath),
                  );
                }}
                data={{
                  img: `${photoBasePath}/${item.user_photo &&
                    item.user_photo.fullPath}`,
                  name: item.user_name,
                  text: item.description,
                  role: translateUserPosition(item.user_role),
                  datetime: moment(item.created_date),
                }}
              />
            );
          })}
        {readOnly && status !== 'closed' && (
          <CommentItem
            onMessageSave={e => this.saveToHistory(e)}
            data={{
              name: `${this.props.user.name} ${this.props.user.surname}`,
              role: translateUserPosition('customer'),
              datetime: moment(),
            }}
          />
        )}
        <InputWrapper>
          <DescWrapper>
            <EmailsSelector
              defaultEmails={defaultEmails}
              emails={additionalEmails}
              onDelete={email => {
                const additionalEmailsCopy = [...additionalEmails];
                const index = additionalEmailsCopy.indexOf(email);
                if (index !== -1) {
                  additionalEmailsCopy.splice(index, 1);
                  this.setState({ additionalEmails: additionalEmailsCopy });
                }
              }}
              onAdd={email => {
                const additionalEmailsCopy = [...additionalEmails];
                const index = additionalEmailsCopy.indexOf(email);
                if (
                  index === -1 &&
                  email !== this.props.user.email &&
                  email !== firmEmail
                ) {
                  additionalEmailsCopy.push(email);
                  this.setState({ additionalEmails: additionalEmailsCopy });
                }
              }}
            />
          </DescWrapper>
        </InputWrapper>
        {status !== 'closed' && (
          <ButtonWrapper>
            <CustomButton
              danger
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth',
                });
                this.props.history.push('/helpdesk');
              }}
            >
              {__('Zrušiť')}
            </CustomButton>
            <CustomButton
              primary
              loading={saveLoading}
              onClick={() => this.onSubmit()}
            >
              {__('Uložiť')}
            </CustomButton>
          </ButtonWrapper>
        )}
      </MainContainer>
    );
  }
}

HelpdeskDetial.PropTypes = {
  location: PropTypes.shape.isRequired,
  user: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(HelpdeskDetial);



// WEBPACK FOOTER //
// ./src/Containers/Helpdesk/Detail/index.jsx